module.exports = __webpack_public_path__ + "assets/img/0_04.b4492ffb.png";